import { Box, Typography } from "@mui/material";
import { FaClock } from "react-icons/fa6";
import { late, lateLine, lateWash } from "./tableStyles";

export default function OverdueStamp({ days = 1 }) {
    const label = Number(days) === 1 ? "1 dia" : `${days} dias`;

    return (
        <Box
            component="span"
            sx={styles.wrap}
            aria-label={`Atrasado há ${label}`}
        >
            <Box component={FaClock} size={11} color={late} aria-hidden />
            <Typography component="span" sx={styles.word}>
                Atrasado
            </Typography>
            <Box component="span" sx={styles.days}>
                {label}
            </Box>
        </Box>
    );
}

const styles = {
    wrap: {
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        minHeight: 24,
    },
    word: {
        color: late,
        fontWeight: 700,
        fontSize: 11,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        lineHeight: 1,
    },
    days: {
        px: 1,
        py: 0.25,
        border: `1px solid ${lateLine}`,
        bgcolor: lateWash,
        color: late,
        fontSize: 12,
        fontWeight: 600,
        borderRadius: 1,
        fontVariantNumeric: "tabular-nums",
        lineHeight: 1.2,
    },
};
